import { DotsHorizontalCircleIcon } from './DotsHorizontalCircleIcon';

/**
 * author: Google
 * id 2ED6A664-DAE9-427C-8810-496C331C9BE0
 * name dots-horizontal-circle
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-horizontal-circle.svg
 * tags
 */
export const MoreCircleIcon = DotsHorizontalCircleIcon;
export default MoreCircleIcon